module.exports = require("antd/es/icon");